import React from 'react';
import { Link } from 'gatsby';

import SEO from '../components/seo';
import Header from '../components/Header';
import Footer from '../components/Footer';

import '../components/layout.css';

const DiligencePage = () => (
  <div className="theme-default bg-background text-foreground">
    <SEO title="Due Diligence" />
    <Header />

    <main>
      {/* OCF secondaryHero */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <span className="chip mb-6 inline-flex">For procurement &amp; investors</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight mt-4">
            Due Diligence
          </h1>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: purpose */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Purpose</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="prose prose-lg max-w-none">
                <p>
                  LongStraw maintains comprehensive technical diligence packages
                  for carbon removal procurement desks, institutional investors,
                  and independent diligence rating agencies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: key facts */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Key facts</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Registry
                  </div>
                  <p className="text-base leading-relaxed">
                    <a
                      href="https://registry.isometric.com/project/6PQZ"
                      className="underline hover:text-accent"
                    >
                      Isometric registry: 6PQZ
                    </a>
                  </p>
                </div>
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Methodology
                  </div>
                  <p className="text-base leading-relaxed">
                    Isometric Biochar Storage in Soil Environments Module
                  </p>
                </div>
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Durability
                  </div>
                  <p className="text-base leading-relaxed">
                    200-year permanence tier
                  </p>
                </div>
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Commercial status
                  </div>
                  <p className="text-base leading-relaxed">
                    Operational (2026)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: request access */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Request access</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="bg-background-raised rounded border border-border p-8">
                <p className="text-base leading-relaxed mb-6">
                  Complete technical diligence packages are available to
                  qualified procurement desks, institutional investors, and
                  independent diligence rating agencies.
                </p>
                <Link to="/contact" className="button-split group">
                  <span className="button-split-circle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </span>
                  <span className="button-split-pill">
                    Request diligence access
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default DiligencePage;
